export default "__VITE_ASSET__LgkmWxNQ__"